"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChildrenWithNavigationType = void 0;
const getChildrenWithNavigationType = (linkType, data) => data?.children.find(item => item.linkType === linkType);
exports.getChildrenWithNavigationType = getChildrenWithNavigationType;
